var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 3.20831H17.7083V2.1666C17.7083 1.01763 16.774 0.083252 15.625 0.083252H9.375C8.22603 0.083252 7.29165 1.01758 7.29165 2.1666V3.20826H2.08335C0.934326 3.20831 0 4.14263 0 5.29161V8.41661C0 9.56564 0.934326 10.5 2.08335 10.5H10.4167V9.97911C10.4167 9.69122 10.6497 9.45827 10.9375 9.45827H14.0625C14.3504 9.45827 14.5834 9.69122 14.5834 9.97911V10.5H22.9167C24.0657 10.5 25 9.56564 25 8.41661V5.29161C25 4.14263 24.0657 3.20831 22.9167 3.20831ZM15.625 3.20831H9.375V2.1666H15.625V3.20831Z",
    fill: "#FFBB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7111 11.062C24.5336 10.974 24.3215 10.9943 24.1648 11.1133C23.7945 11.3936 23.3632 11.5416 22.9166 11.5416H14.5833V13.1041C14.5833 13.392 14.3504 13.625 14.0625 13.625H10.9375C10.6496 13.625 10.4166 13.392 10.4166 13.1041V11.5416H2.08335C1.63677 11.5416 1.20547 11.3936 0.835156 11.1133C0.677979 10.9933 0.466406 10.9729 0.288867 11.062C0.111914 11.15 0 11.3305 0 11.5284V18.8333C0 19.9823 0.934326 20.9167 2.08335 20.9167H22.9167C24.0657 20.9167 25 19.9823 25 18.8333V11.5284C25 11.3305 24.8881 11.15 24.7111 11.062Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag2);
export default __webpack_public_path__ + "static/media/bag2.c1b9f27f0c87fe3d1da3b123e5cd3a40.svg";
export { ForwardRef as ReactComponent };